/**
 * Custom Lamp Product — Orfentra
 * Galería deslizable + animaciones scroll-reveal.
 * No toca el carrito/checkout: eso lo maneja Dawn de forma nativa
 * (product-form.js / product-info.js / variant-selects en global.js).
 */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initScrollReveal(root) {
    var targets = root.querySelectorAll('.scroll-reveal');
    if (!targets.length) return;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('is-in-view');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry, index) {
          if (entry.isIntersecting) {
            var el = entry.target;
            setTimeout(function () {
              el.classList.add('is-in-view');
            }, Math.min(index * 60, 240));
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initGallery(gallery) {
    var track = gallery.querySelector('[data-lamp-track]');
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-media-id]'));
    var dotsWrap = gallery.querySelector('[data-lamp-dots]');
    var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-lamp-dot]')) : [];
    var prevBtn = gallery.querySelector('[data-lamp-prev]');
    var nextBtn = gallery.querySelector('[data-lamp-next]');
    if (!track || !slides.length) return;

    var current = 0;
    slides.forEach(function (slide, i) {
      if (slide.classList.contains('is-active')) current = i;
    });

    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      current = index;

      track.style.transform = 'translateX(-' + index * 100 + '%)';

      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function goToMediaId(mediaId) {
      var index = slides.findIndex(function (slide) {
        return slide.dataset.mediaId === mediaId;
      });
      if (index > -1) goTo(index);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });

    // swipe touch support
    var touchStartX = null;
    track.addEventListener(
      'touchstart',
      function (e) {
        touchStartX = e.touches[0].clientX;
      },
      { passive: true }
    );
    track.addEventListener(
      'touchend',
      function (e) {
        if (touchStartX === null) return;
        var deltaX = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(deltaX) > 40) {
          goTo(current + (deltaX < 0 ? 1 : -1));
        }
        touchStartX = null;
      },
      { passive: true }
    );

    goTo(current);
    gallery.lampGoToMediaId = goToMediaId;
  }

  function initVariantSync(productInfo) {
    var gallery = productInfo.querySelector('[data-lamp-gallery]');
    if (!gallery) return;

    var radios = productInfo.querySelectorAll('.lamp-variants__radio');
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        var mediaId = radio.getAttribute('data-variant-media-id');
        if (mediaId && typeof gallery.lampGoToMediaId === 'function') {
          gallery.lampGoToMediaId(mediaId);
        }
      });
    });
  }

  function initStickyCta(productInfo) {
    var sticky = productInfo.querySelector('[data-lamp-sticky-cta]');
    var mainCta = productInfo.querySelector('.lamp-cta');
    if (!sticky || !mainCta) return;

    var dataScript = productInfo.querySelector('[data-lamp-variants-json]');
    var variantsData = {};
    if (dataScript) {
      try {
        variantsData = JSON.parse(dataScript.textContent);
      } catch (e) {
        variantsData = {};
      }
    }

    var thumb = sticky.querySelector('[data-lamp-sticky-thumb]');
    var nameEl = sticky.querySelector('[data-lamp-sticky-name]');
    var currentPriceEl = sticky.querySelector('[data-lamp-sticky-price-current]');
    var compareEl = sticky.querySelector('[data-lamp-sticky-price-compare]');
    var submitBtn = sticky.querySelector('[data-lamp-sticky-submit]');

    function updateStickyForVariant(variantId) {
      var data = variantsData[variantId];
      if (!data) return;

      if (thumb) {
        thumb.src = data.image;
        thumb.alt = data.title;
      }
      if (nameEl) nameEl.textContent = data.title;
      if (currentPriceEl) currentPriceEl.textContent = data.price;

      if (data.compareAtPrice) {
        if (compareEl) {
          compareEl.textContent = data.compareAtPrice;
        } else if (currentPriceEl) {
          compareEl = document.createElement('s');
          compareEl.setAttribute('data-lamp-sticky-price-compare', '');
          compareEl.textContent = data.compareAtPrice;
          currentPriceEl.insertAdjacentElement('afterend', compareEl);
        }
      } else if (compareEl) {
        compareEl.remove();
        compareEl = null;
      }

      if (submitBtn) {
        submitBtn.disabled = !data.available;
        submitBtn.textContent = data.available ? 'Agregar al carrito' : 'Agotado';
      }
    }

    // Sincroniza la barra sticky cuando cambia la variante seleccionada.
    var radios = productInfo.querySelectorAll('.lamp-variants__radio');
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        var variantId = radio.getAttribute('data-variant-id');
        if (variantId) updateStickyForVariant(variantId);
      });
    });

    // El botón sticky no agrega al carrito por su cuenta: dispara un
    // click real sobre el botón principal, así usa exactamente el
    // mismo mecanismo de Dawn (product-form.js / cart real).
    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        if (submitBtn.disabled) return;
        var mainButton = document.getElementById(
          'ProductSubmitButton-' + submitBtn.getAttribute('data-section-id')
        );
        if (mainButton) mainButton.click();
      });
    }

    // Se muestra recién cuando el bloque de compra principal sale de
    // la vista hacia arriba (ya lo pasamos scrolleando), no antes de
    // llegar a él. Chequeo directo de posición en cada scroll (más
    // simple y confiable que IntersectionObserver).
    var ticking = false;
    function updateVisibility() {
      var rect = mainCta.getBoundingClientRect();
      var pastIt = rect.bottom < 0;
      sticky.classList.toggle('is-visible', pastIt);
      sticky.setAttribute('aria-hidden', pastIt ? 'false' : 'true');
      ticking = false;
    }
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(updateVisibility);
        }
      },
      { passive: true }
    );
    window.addEventListener('resize', updateVisibility);
    updateVisibility();
  }

  function initSizeCard(productInfo) {
    var card = productInfo.querySelector('[data-lamp-size]');
    if (!card) return;

    var dataScript = productInfo.querySelector('[data-lamp-variants-json]');
    var variantsData = {};
    if (dataScript) {
      try {
        variantsData = JSON.parse(dataScript.textContent);
      } catch (e) {
        variantsData = {};
      }
    }

    var thumb = card.querySelector('[data-lamp-size-thumb]');
    var widthEl = card.querySelector('[data-lamp-size-width]');
    var heightEl = card.querySelector('[data-lamp-size-height]');
    var nameEl = card.querySelector('[data-lamp-size-name]');

    function updateSizeForVariant(variantId) {
      var data = variantsData[variantId];
      if (!data) return;
      if (thumb) {
        thumb.src = data.image;
        thumb.alt = data.title;
      }
      if (widthEl) widthEl.textContent = data.widthCm;
      if (heightEl) heightEl.textContent = data.heightCm;
      if (nameEl) nameEl.textContent = data.title;
    }

    var radios = productInfo.querySelectorAll('.lamp-variants__radio');
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        var variantId = radio.getAttribute('data-variant-id');
        if (variantId) updateSizeForVariant(variantId);
      });
    });
  }

  function initFreebiePicker(root) {
    var widget = root.querySelector('[data-lamp-freebie]');
    if (!widget) return;

    var checkboxes = Array.prototype.slice.call(widget.querySelectorAll('[data-lamp-freebie-checkbox]'));
    var status = widget.querySelector('[data-lamp-freebie-status]');
    var submitBtn = widget.querySelector('[data-lamp-freebie-submit]');
    var successBox = widget.querySelector('[data-lamp-freebie-success]');
    var successText = successBox ? successBox.querySelector('.lamp-freebie__success-text') : null;
    var addUrl = widget.getAttribute('data-cart-add-url');
    var submitting = false;

    function checkedBoxes() {
      return checkboxes.filter(function (cb) { return cb.checked; });
    }

    function setStatus(text) {
      if (status) status.textContent = text;
    }

    function messageFor(count) {
      if (count === 0) return 'Elegí 2 o más animalitos';
      if (count === 1) return 'Elegiste 1 — elegí 1 más para envío gratis';
      if (count === 2) return '¡Envío gratis aplicado! Elegí el 3ro y sumás 15% off';
      return '¡15% off + envío gratis aplicados! 🎉';
    }

    function refresh() {
      if (submitting) return;
      var count = checkedBoxes().length;
      setStatus(messageFor(count));
      if (submitBtn) {
        submitBtn.disabled = count < 2;
        submitBtn.textContent = count >= 2 ? 'Agregar ' + count + ' al carrito' : 'Agregar al carrito';
      }
      if (successBox) successBox.hidden = true;
    }

    function addToCart() {
      var checked = checkedBoxes();
      if (checked.length < 2 || submitting) return;

      submitting = true;
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Agregando...';
      }
      setStatus('Agregando al carrito...');

      var items = checked.map(function (box) {
        return { id: parseInt(box.value, 10), quantity: 1 };
      });

      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('cart add failed');
          return response.json();
        })
        .then(function () {
          submitting = false;
          if (successText) {
            successText.textContent =
              checked.length >= 3
                ? '¡Listo! Agregamos tus 3 animalitos (15% off + envío gratis).'
                : '¡Listo! Agregamos tus animalitos (envío gratis).';
          }
          if (successBox) successBox.hidden = false;
          setStatus(messageFor(checked.length));
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Agregar ' + checked.length + ' más al carrito';
          }
          document.dispatchEvent(new CustomEvent('lamp:cart-updated'));
        })
        .catch(function () {
          submitting = false;
          setStatus('Uy, algo falló. Intentá de nuevo.');
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Agregar al carrito';
          }
        });
    }

    checkboxes.forEach(function (cb) {
      cb.addEventListener('change', refresh);
    });
    if (submitBtn) {
      submitBtn.addEventListener('click', addToCart);
    }

    refresh();
  }

  function initBackButton(root) {
    var backLink = root.querySelector('[data-lamp-back]');
    if (!backLink) return;

    backLink.addEventListener('click', function (e) {
      var cameFromSameSite = document.referrer && document.referrer.indexOf(window.location.origin) === 0;
      if (cameFromSameSite && window.history.length > 1) {
        e.preventDefault();
        window.history.back();
      }
      // si no hay de dónde volver (llegó por link directo/nueva pestaña),
      // sigue el href normal del link (inicio de la tienda).
    });
  }

  function init() {
    document.querySelectorAll('.lamp-product').forEach(function (productInfo) {
      initScrollReveal(productInfo);
      var gallery = productInfo.querySelector('[data-lamp-gallery]');
      if (gallery) initGallery(gallery);
      initVariantSync(productInfo);
      initFreebiePicker(productInfo);
      initBackButton(productInfo);
      initStickyCta(productInfo);
      initSizeCard(productInfo);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();